const toSafeUserStateString = (value) => {
  const normalized = String(value || '').trim();

  return normalized || null;
};

export default toSafeUserStateString;
